export enum FullCalendarViewTypes {
  MONTH = 'dayGridMonth',
  WEEK = 'timeGridWeek',
  SCHOOL_WEEK = 'timeGridSchoolWeek',
  THREE_DAY = 'timeGridThreeDay',
  DAY = 'timeGridDay',
}
